import { ReceptionServiceTableBean } from '../extensions/calendar/appointment/interactiveTable/ReceptionServiceInteractiveTable.types';

export const getCalculatedTotalEstimatedDuration = (receptionServices: ReceptionServiceTableBean[]): number => {
   return receptionServices.reduce((total, { receptionService }) => {
      if (receptionService.estimatedDuration) {
         return total + receptionService.estimatedDuration.asMinutes();
      }

      return total;
   }, 0);
};
